import { Component, EventEmitter, Input, Output } from '@angular/core';

type ButtonVariant = 'contained' | 'outlined' | 'text';

type ButtonType = 'submit' | 'button';

type ButtonSize = 'small' | 'medium' | 'large';

type ButtonSeverity =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  @Input() plain = false;
  @Input() label = 'Submit';
  @Input() link = false;
  @Input() startIcon = '';
  @Input() endIcon = '';
  @Input() loading = false;
  @Input() disabled = false;
  @Input() severity: ButtonSeverity = 'primary';
  @Input() rounded = true;
  @Input() raised = false;
  @Input() size: ButtonSize = 'medium';
  @Input() variant: ButtonVariant = 'contained';
  @Input() fullWidth: Boolean = false;
  @Input() type: ButtonType = 'button';
  @Input() isElongated: boolean = false;
  @Input() isElongated_med: boolean = false;
  @Input() isBtnWhite: boolean = false;
  @Input() isSelected: boolean = false;
  /**
   * Holds the name of classes that are used by the element.
   * Margin bottom of 8px (mb-2) is used as default
   */
  className: string = '';

  @Output() sendClick = new EventEmitter();

  onClick(event: MouseEvent) {
    this.sendClick.emit(event);
  }

  getButtonClass(): string {
    return [
      'flex items-center justify-center',
      this.fullWidth ? 'w-full' : '',
      this.size === 'small' ? 'text-sm' : '',
      'font-bold text-base whitespace-nowrap hover:shadow-dropShadow active:shadow-dropShadowInner',
      'disabled:shadow-none disabled:opacity-100',
      this.isElongated ? 'btn-elongated' : '',
      this.isElongated_med ? 'btn-elongated-med' : '',
      this.isBtnWhite ? 'btn-white' : '',
      this.isSelected ? 'btn-selected' : '',
      this.variant === 'contained'
        ? 'disabled:border-none disabled:bg-grayedOut'
        : 'disabled:text-grayedOut',
    ]
      .filter(Boolean)
      .join(' ');
  }
}
